import { useInfiniteQuery } from "@tanstack/react-query";
import { manageArticleApi } from "@/entities/article";
import { articleQueryKeys } from "@/entities/article";
import { useSearchParams } from "react-router-dom";
import { SORT_TYPE } from "@/types/enum.ts";

interface UseArticleListQueryProps {
  selectedSortType?: SORT_TYPE;
}

export const useArticleListQuery = ({
  selectedSortType,
}: UseArticleListQueryProps = {}) => {
  const [searchParams] = useSearchParams();

  // 정렬 파라미터를 생성
  const getSortParams = () => {
    if (selectedSortType === SORT_TYPE.OLDEST) {
      return { sortBy: "created_at", sortOrder: "asc" };
    }
    return { sortBy: "created_at", sortOrder: "desc" }; // 기본값은 최신순
  };

  return useInfiniteQuery({
    queryKey: [
      ...articleQueryKeys.list(),
      searchParams.toString(),
      selectedSortType,
    ],
    queryFn: async ({ pageParam = 1 }) => {
      const sortParams = getSortParams();
      const result = await manageArticleApi.getArticleListPaginated(
        pageParam,
        10,
        searchParams.toString(),
        sortParams.sortBy,
        sortParams.sortOrder,
      );
      return result;
    },
    getNextPageParam: (lastPage, allPages) => {
      return lastPage.hasMore ? allPages.length + 1 : undefined;
    },
    initialPageParam: 1,
    staleTime: 5 * 60 * 1000, // 5분
    gcTime: 10 * 60 * 1000, // 10분
  });
};
